import type { WorkClassification } from "../../domain/operations";
import { workClassLabels, workClassifications } from "../../domain/operations";

export function EventExecutionMeters({ percents, compact = false }: { percents: Record<WorkClassification, number>; compact?: boolean }) {
  return (
    <div className={`execution-meters ${compact ? "compact" : ""}`} aria-label="Execution state">
      {workClassifications.map((classification) => (
        <article key={classification}>
          <span>{workClassLabels[classification]}</span>
          <strong>{percents[classification]}%</strong>
          <div><i style={{ width: `${percents[classification]}%` }} /></div>
        </article>
      ))}
    </div>
  );
}
